var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-card',{staticClass:"ma-3 elevation-6 blue-grey lighten-1",attrs:{"max-width":"600","min-width":"250"}},[_c('v-card-title',[_vm._v("Clouds coverage")]),_c('v-img',{staticClass:"ma-3",attrs:{"src":"https://data.webastro.net/metastro/metastrogramme.php?&lat=59.601102&long=16.573135"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }